// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f6e28ebe4e514a5a1507663661f9ffb1d9ec7573/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};